exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Loader--loader--239CI{display:flex;pointer-events:none}.Loader--loaderDots--IcVlR{opacity:1;transition:opacity .25s ease;z-index:10;top:50%;align-items:center;height:100%}.Loader--loaderDots--IcVlR,.Loader--loaderText--10JJd{display:flex;position:absolute;left:50%;transform:translate(-50%,-50%);justify-content:center;width:100%}.Loader--loaderText--10JJd{color:var(--text-high-contrast);font-size:14px;top:calc(50% + 29px)}.Loader--loaderDots--IcVlR.Loader--overlay--SAerc{background:radial-gradient(hsla(0,0%,100%,.9),hsla(0,0%,100%,.7))}.Loader--loaderDots--IcVlR.Loader--hidden--2YWt4{opacity:.01}.Loader--loaderDot--1B5L3{margin:5px;width:16px;height:16px;border-radius:50%;background:var(--brand-purple-dark);transform:scale(.5);animation:Loader--scale-dot--29bkn 1.2s ease-out infinite}.Loader--loaderDot--1B5L3:nth-of-type(2){animation-delay:.2s}.Loader--loaderDot--1B5L3:nth-of-type(3){animation-delay:.3s}.Loader--loaderDot--1B5L3:nth-of-type(4){animation-delay:.4s}.Loader--loaderDot--1B5L3:nth-of-type(5){animation-delay:.5s}@keyframes Loader--scale-dot--29bkn{0%{transform:scale(.5)}25%{transform:scale(1)}75%{transform:scale(.5)}to{transform:scale(.5)}}", ""]);

// exports
exports.locals = {
	"loader": "Loader--loader--239CI",
	"loaderDots": "Loader--loaderDots--IcVlR",
	"loaderText": "Loader--loaderText--10JJd",
	"overlay": "Loader--overlay--SAerc",
	"hidden": "Loader--hidden--2YWt4",
	"loaderDot": "Loader--loaderDot--1B5L3",
	"scale-dot": "Loader--scale-dot--29bkn"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/components/common/loader/Loader.css
 ** module id = 34
 ** module chunks = 0
 **/